import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { InfoBarBlock as InfoBarBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

export const InfoBarBlock = (
    props: Immutable<{ value: InfoBarBlockValue }>,
): React.JSX.Element => {
    const v = props.value;
    // Legacy rendered `{% for column in value.info %}{% include_block column %}`
    // where each `column` is a raw RichText value (a ListBlock(RichTextBlock)
    // child), so `include_block` emits the BARE expanded richtext HTML (a `<p>`)
    // with NO `.rich-text` wrapper -- these bare paragraphs are the direct flex
    // children of `.info-bar-block > div` (display:flex; flex-wrap:wrap). Wrapping
    // each in a `.rich-text` div (flex:1) instead produced narrow per-word columns,
    // so inject the concatenated bare richtext directly into the flex div.
    return (
        <section
            className={concatClassNames([
                "info-bar-block",
                v.theme?.theme ?? "",
                v.text_style ?? "",
                v.background_style?.style ?? "",
                getGlobalSpacingClasses(v.spacing),
            ])}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: (v.info ?? []).join(""),
                }}
            />
        </section>
    );
};
